import { render } from "./battery.vue?vue&type=template&id=5d38ebbc&scoped=true"
import script from "./battery.vue?vue&type=script&lang=js"
export * from "./battery.vue?vue&type=script&lang=js"

import "./battery.vue?vue&type=style&index=0&id=5d38ebbc&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d38ebbc"]])

export default __exports__